<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    label: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { label, onclick }: Props = $props();
</script>

<div class="comp-review-banner" class:error={!label}>
  {#if label}
    <Icon value="icon-alert-triangle" />
    <div class="label">
      {label}
    </div>
    <button type="button" class="action-button" {onclick}>Review Now</button>
  {:else}
    <div class="error-label">Invalid Label</div>
  {/if}
</div>

<style src="./ReviewBanner.css">
</style>
